const drupalSettings = window.drupalSettings || {};

const searchBox = drupalSettings?.widgets?.searchBoxKontoro || {};
const filters = drupalSettings?.widgets?.filtersKontoro || {};

const oneDayBooking = drupalSettings?.oneDayBooking;

const isMultipleBookingEnabled = drupalSettings?.search?.isMultipleBookingEnabled || true;

export {
  searchBox,
  filters,
  oneDayBooking,
  isMultipleBookingEnabled,
};

export default drupalSettings;
